export enum PowerBIReportTypeEnum {
    Report = 0,
    PaginatedReport = 1,
}
